module.exports = __webpack_public_path__ + "images/ivplogo.f491d4a1.webp";